module.exports = __webpack_public_path__ + "static/media/statement.b587573f.png";